// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"fU-z","inlineTitle":"gU-z","sponsoredAdsWrapper":"hU-z","marketplaceRecosWrapper":"iU-z"};